import { motion } from 'framer-motion'
import { useRouter } from 'next/router'
import Container from '@comp/ui/container'
import Heading from '@comp/ui/heading'
import Text from '@comp/ui/text'
import Button from '@comp/ui/button'

const copy = {
  en: {
    title1: 'Ready to start managing',
    title2: 'identities the right way?',
    body: 'Spin up a fully-loaded trial tenant in under five minutes. No credit card. No sales gate.',
    primary: 'Start free trial \u2192',
    secondary: 'Talk with our experts',
  },
  tr: {
    title1: 'Kimlikleri do\u011fru \u015fekilde',
    title2: 'y\u00f6netmeye haz\u0131r m\u0131s\u0131n\u0131z?',
    body: 'Be\u015f dakikadan k\u0131sa s\u00fcrede tam donan\u0131ml\u0131 bir deneme ortam\u0131 kurun. Kredi kart\u0131 yok, sat\u0131\u015f engeli yok.',
    primary: '\u00dccretsiz deneme ba\u015flat \u2192',
    secondary: 'Uzmanlar\u0131m\u0131zla g\u00f6r\u00fc\u015f\u00fcn',
  },
}

export default function FinalCta() {
  const { locale } = useRouter()
  const t = locale === 'tr' ? copy.tr : copy.en
  return (
    <section className="relative bg-surface py-28 lg:py-40" data-density="spacious">
      <Container size="xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="mx-auto max-w-3xl text-center"
        >
          <Heading as="h2" size="display-xl">
            {t.title1}
            <br />
            {t.title2}
          </Heading>
          <Text size="xl" tone="secondary" className="mt-6">
            {t.body}
          </Text>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <Button href="/try/now" variant="primary" size="lg">
              {t.primary}
            </Button>
            <Button href="/contact" variant="outline" size="lg">
              {t.secondary}
            </Button>
          </div>
        </motion.div>
      </Container>
    </section>
  )
}
